import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=7d76ebc3"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d76ebc3')) {
      api.createRecord('7d76ebc3', component.options)
    } else {
      api.reload('7d76ebc3', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=7d76ebc3", function () {
      api.rerender('7d76ebc3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/payments/Index.vue"
export default component.exports